import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getSubProjectIncomeRecord } from '../../../redux/actions/subProjectIncomeRecord'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import { values } from 'lodash-es'
import CoworkerEvaluateThaihealthWidget from '../../../widgets/evaluatesWidgets/coworkerEvaluateThaihealthWidgets/CoworkerEvaluateThaihealthWidget'

export default function CoworkerEvaluateThaihealth() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const subProjectCode = sessionGetItemStr('subProjectCode')
  const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  const subIncomeId = sessionGetItemStr('subIncomeId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const response = await getSubProjectIncomeRecord(subProjectCode, periodNo, subIncomeId)
      // setSchema(response.model)

      setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isEvaluates>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isEvaluates>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isEvaluates>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <CoworkerEvaluateThaihealthWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  affectedRows: 5,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'ภาคีประเมินการทำงานของ สสส.',
    subHeader: '',
    disabled: false,
    form: {
      question: [
        {
          label:
            '1.ท่านได้รับการสนับสนุนจาก สสส.  เพื่อดำเนินงานโครงการนี้ในระดับใด อาทิ สสส. เข้ามาร่วมคิดร่วมวางแผนงาน การให้คำแนะนำปรึกษา ร่วมแก้ไขปัญหา ร่วมเวที/ลงพื้นที่ปฏิบัติงาน เป็นต้น',
          name: 'question1',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' }],
        },
        {
          label: '2.ท่านมีความรู้สึกเป็นส่วนหนึ่งของขบวนการขับเคลื่อนสุขภาพของ สสส. ในระดับใด',
          name: 'question2',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' }],
        },
        {
          label:
            '3.ในฐานะที่ท่านได้ร่วมงานกับทาง สสส. ท่านมีความสุข และมีแรงจูงใจในการดำเนินโครงการ/กิจกรรมอื่น ๆ ต่อไปในระดับใด',
          name: 'question3',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกคำตอบในข้อนี้' }],
        },
      ],
    },
  },
}
